import { render, staticRenderFns } from "./AppWidgetWithIcon.vue?vue&type=template&id=695a4adc"
import script from "./AppWidgetWithIcon.vue?vue&type=script&lang=js"
export * from "./AppWidgetWithIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports